import React, { Component } from 'react';
import {CountryService} from '../service/CountryService';
import {InputText} from 'primereact/inputtext';
import {InputTextarea} from 'primereact/inputtextarea';
import {AutoComplete} from 'primereact/autocomplete';
import {MultiSelect} from 'primereact/multiselect';
import {Calendar} from 'primereact/calendar';
import {Chips} from 'primereact/chips';
import {Checkbox} from 'primereact/checkbox';
import {RadioButton} from 'primereact/radiobutton';
import {InputSwitch} from 'primereact/inputswitch';
import {Dropdown} from 'primereact/dropdown';
import {Password} from 'primereact/password';
import {Spinner} from 'primereact/spinner';
import {Slider} from 'primereact/components/slider/Slider';
import {ListBox} from 'primereact/listbox';
import {Rating} from 'primereact/rating';
import {ColorPicker} from 'primereact/colorpicker';
import {Editor} from 'primereact/editor';
import {ToggleButton} from 'primereact/togglebutton';
import {SelectButton} from 'primereact/selectbutton';
import {Button} from 'primereact/button';
import {SplitButton} from 'primereact/splitbutton';

export class FormsDemo extends Component {

    constructor() {
        super();
        this.state = {
            countriesData: [],
            cars: [],
            selectedType: null,
            chipsValue: [],
            date1: null,
            date2: null,
            date3: null,
            date4: null,
            date5: null,
            date6: null,
            date7: null,
            checkboxValue: [],
            radioValue: null,
            inputSwitchValue: false,
            dropdownCity: null,
            spinnerValue: null,
            sliderValue: [20,80],
            listBoxCity: null,
            ratingValue: null,
            colorPickerValue: null,
            inputGroupValue: null,
            carOptions: [
                {label: 'Audi', value: 'Audi'},
                {label: 'BMW', value: 'BMW'},
                {label: 'Fiat', value: 'Fiat'},
                {label: 'Honda', value: 'Honda'},
                {label: 'Jaguar', value: 'Jaguar'},
                {label: 'Mercedes', value: 'Mercedes'},
                {label: 'Renault', value: 'Renault'},
                {label: 'VW', value: 'VW'},
                {label: 'Volvo', value: 'Volvo'}
            ],
            cities: [
                {label: 'Select City', value: null},
                {label: 'New York', value: 'New York'},
                {label: 'Rome', value: 'Rome'},
                {label: 'London', value: 'London'},
                {label: 'Istanbul', value: 'Istanbul'},
                {label: 'Paris', value: 'Paris'}
            ],
            listBoxCities: [
                {label: 'Madrid', value: 'Madrid'},
                {label: 'Geneva', value: 'Geneva'},
                {label: 'Los Angeles', value: 'Los Angeles'},
                {label: 'Monaco', value: 'Monaco'},
                {label: 'Berlin', value: 'Berlin'}
            ],
            types: [
                {label: 'Apartment', value: 'Apartment'},
                {label: 'House', value: 'House'},
                {label: 'Studio', value: 'Studio'}
            ],
            splitButtonItems: [
                {label: 'Update', icon: 'pi-md-update'},
                {label: 'Delete', icon: 'pi-md-close'},
                {label: 'Home', icon: 'pi-md-home', url: 'http://www.primefaces.org/primereact'}
            ]
        };

        this.countryService = new CountryService();
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
        this.filterCountry = this.filterCountry.bind(this);
        this.filterBrands = this.filterBrands.bind(this);
        this.autoCompleteItemTemplate = this.autoCompleteItemTemplate.bind(this);
    }

    componentDidMount(){
        this.setState({countriesData: this.countryService.getCountries(this)})
        this.brands = ['Audi', 'BMW', 'Fiat', 'Ford', 'Honda', 'Jaguar', 'Mercedes', 'Renault', 'Volvo'];
    }

    filterCountry(event) {
        let results = this.state.countriesData.filter((country) => {
            return country.name.toLowerCase().startsWith(event.query.toLowerCase());
        });
        this.setState({ filteredCountries: results });
    }

    filterBrands(event) {
        setTimeout(() => {
            let results;

            if (event.query.length === 0) {
                results = [...this.brands];
            }
            else {
                results = this.brands.filter((brand) => {
                    return brand.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            this.setState({ filteredBrands: results });
        }, 250);
    }

    autoCompleteItemTemplate(brand) {
        if (!brand) {
            return;
        }

        return (
                <div className="p-clearfix">
                    <img alt={brand} src={`assets/demo/images/car/${brand}.gif`} style={{ width: '32px', display: 'inline-block', margin: '5px 0 2px 5px' }} />
                    <div style={{ fontSize: '18px', float: 'right', margin: '10px 10px 0 0' }}>{brand}</div>
                </div>
        );
    }

    onCheckboxChange(event){
        let selected = [...this.state.checkboxValue];
        if (event.checked)
            selected.push(event.value);
        else
            selected.splice(selected.indexOf(event.value), 1);

        this.setState({checkboxValue: selected});
    }

    render() {
        return (
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-lg-6">
                    <div className="card">
                        <div className="card-title">InputText</div>
                        <div className="p-grid form-group">
                            <div className="p-col-12 p-md-4">
                                <span className="md-inputfield">
                                    <InputText/>
                                    <label>Name</label>
                                </span>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <span className="md-inputfield">
                                    <InputText/>
                                    <label>Email</label>
                                </span>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <span className="md-inputfield">
                                    <InputText/>
                                    <label>Phone</label>
                                </span>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <span className="md-inputfield">
                                    <InputText/>
                                    <label>Address</label>
                                </span>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <span className="md-inputfield">
                                    <InputText disabled={true}/>
                                    <label>Disabled</label>
                                </span>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <span className="md-inputfield">
                                    <InputText className="p-error" placeholder="Invalid"/>
                                </span>
                            </div>
                        </div>
                        <div className="card-title">Filled InputText</div>
                        <div className="p-grid form-group">
                            <div className="p-col-12 p-md-4">
                            <span className="md-inputfield md-inputfield-fill">
                                <InputText/>
                                <label>Name</label>
                            </span>
                            </div>
                            <div className="p-col-12 p-md-4">
                            <span className="md-inputfield md-inputfield-fill">
                                <InputText/>
                                <label>Email</label>
                            </span>
                            </div>
                            <div className="p-col-12 p-md-4">
                            <span className="md-inputfield md-inputfield-fill">
                                <InputText/>
                                <label>Phone</label>
                            </span>
                            </div>
                        </div>

                        <div className="card-title">TextBox</div>
                        <div className="p-grid form-group">
                            <div className="p-col-12 p-md-4">
                            <span className="md-inputfield md-inputfield-box">
                                <InputText/>
                                <label>Name</label>
                            </span>
                            </div>
                            <div className="p-col-12 p-md-4">
                            <span className="md-inputfield md-inputfield-box">
                                <InputText/>
                                <label>Email</label>
                            </span>
                            </div>
                            <div className="p-col-12 p-md-4">
                            <span className="md-inputfield md-inputfield-box">
                                <InputText/>
                                <label>Phone</label>
                            </span>
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-title">TextArea</div>
                        <InputTextarea rows={3} cols={30} placeholder="Your Message" autoResize={true} />
                    </div>

                    <div className="card">
                        <div className="card-title">AutoComplete</div>
                        <div className="p-grid">
                            <div className="p-col-12">
                                <label htmlFor="acSimple">Simple</label>
                            </div>
                            <div className="p-col-12" style={{marginBottom:'10px'}}>
                                <AutoComplete minLength={1} placeholder="Countries" id="acSimple" size={30} field="name" suggestions={this.state.filteredCountries}
                                            completeMethod={this.filterCountry} value={this.state.country} onChange={event => this.setState({ country: event.value, filteredCountries: null})} />
                            </div>
                            <div className="p-col-12">
                                <label htmlFor="acAdvanced">Advanced</label>
                            </div>
                            <div className="p-col-12">
                                <AutoComplete minLength={1} placeholder="Hint: type 'v' or 'f'" id="acAdvanced" size={30} dropdown={true} multiple={true}
                                            suggestions={this.state.filteredBrands} completeMethod={this.filterBrands} value={this.state.brand}
                                            onChange={event => this.setState({ brand: event.value, filteredBrands: null})} itemTemplate={this.autoCompleteItemTemplate} />
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-title">Calendar</div>
                        <Calendar value={this.state.date1} onChange={(e) => this.setState({date1: e.value})} inline={true} />

                        <div className="p-grid form-group-m" style={{marginTop:'20px'}}>
                            <div className="p-col-12">
                                <Calendar placeholder="Popup" value={this.state.date2} onChange={(e) => this.setState({date2: e.value})}/>
                            </div>
                            <div className="p-col-12">
                                <Calendar placeholder="DateTime" showTime={true} dateFormat="mm/dd/yy" value={this.state.date3} onChange={(e) => this.setState({date3: e.value})}/>
                            </div>
                            <div className="p-col-12">
                                <Calendar placeholder="Time" timeOnly={true} showTime={true} value={this.state.date4} onChange={(e) => this.setState({date4: e.value})}/>
                            </div>
                            <div className="p-col-12">
                                <Calendar placeholder="Button" showIcon={true} value={this.state.date5} onChange={(e) => this.setState({date5: e.value})}/>
                            </div>
                            <div className="p-col-12">
                                <Calendar readOnly={true} placeholder="Multiple Months" numberOfMonths={3} value={this.state.date6} onChange={(e) => this.setState({date6: e.value})}/>
                            </div>
                            <div className="p-col-12">
                                <Calendar readOnly={true} dateFormat="mm/yy" placeholder="Month Picker" view="month" value={this.state.date7} onChange={(e) => this.setState({date7: e.value})}/>
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-title">Chips</div>
                        <Chips value={this.state.chipsValue} onChange={(e) => this.setState({chipsValue: e.value})}/>
                    </div>
                </div>
                <div className="p-col-12 p-lg-6">
                    <div className="card">
                        <div className="card-title">Checkboxes</div>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-4">
                                <Checkbox value="Ultima" inputId="cb1" onChange={this.onCheckboxChange} checked={this.state.checkboxValue.indexOf('Ultima') > -1} />
                                <label htmlFor="cb1" className="p-checkbox-label">Ultima</label>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <Checkbox value="Avalon" inputId="cb2" onChange={this.onCheckboxChange} checked={this.state.checkboxValue.indexOf('Avalon') > -1} />
                                <label htmlFor="cb2" className="p-checkbox-label">Avalon</label>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <Checkbox value="Serenity" inputId="cb3" onChange={this.onCheckboxChange} checked={this.state.checkboxValue.indexOf('Serenity') > -1} />
                                <label htmlFor="cb3" className="p-checkbox-label">Serenity</label>
                            </div>
                        </div>

						<div className="card-title">RadioButtons</div>
						<div className="p-grid">
							<div className="p-col-12 p-md-4">
								<RadioButton value="Ultima" inputId="rb1" onChange={event => this.setState({radioValue: event.value})} checked={this.state.radioValue === "Ultima"}/>
								<label htmlFor="rb1" className="p-radiobutton-label">Ultima</label>
							</div>
							<div className="p-col-12 p-md-4">
								<RadioButton value="Avalon" inputId="rb2" onChange={event => this.setState({radioValue: event.value})} checked={this.state.radioValue === "Avalon"}/>
								<label htmlFor="rb2" className="p-radiobutton-label">Avalon</label>
							</div>
							<div className="p-col-12 p-md-4">
								<RadioButton value="Serenity" inputId="rb3" onChange={event => this.setState({radioValue: event.value})} checked={this.state.radioValue === "Serenity"}/>
								<label htmlFor="rb3" className="p-radiobutton-label">Serenity</label>
							</div>
						</div>
                    </div>

					<div className="card">
						<div className="card-title">Dropdown</div>
						<Dropdown options={this.state.cities} value={this.state.dropdownCity} onChange={event => this.setState({dropdownCity: event.value})} autoWidth={false} />

						<div className="card-title">MultiSelect</div>
						<MultiSelect value={this.state.cars} options={this.state.carOptions} placeholder="Choose" onChange={event => this.setState({cars: event.value})} filter={true}/>
					</div>

					<div className="card">
						<div className="card-title">ListBox</div>
						<ListBox options={this.state.listBoxCities} value={this.state.listBoxCity} onChange={event => this.setState({listBoxCity: event.value})} filter={true} />
					</div>

					<div className="card">
						<div className="card-title">Password</div>
						<Password/>
					</div>

					<div className="card">
						<div className="card-title">Spinner</div>
						<Spinner value={this.state.spinnerValue} onChange={event => this.setState({spinnerValue: event.value})} />
					</div>

					<div className="card">
						<div className="card-title">Rating</div>
						<Rating value={this.state.ratingValue} onChange={event => this.setState({ratingValue: event.value})} />
					</div>

					<div className="card">
						<div className="card-title">InputSwitch</div>
						<InputSwitch checked={this.state.inputSwitchValue} onChange={event => this.setState({inputSwitchValue: event.value})} />
					</div>

					<div className="card">
						<div className="card-title">Slider</div>
						<Slider range={true} value={this.state.sliderValue} onChange={event => this.setState({sliderValue: event.value})} />
					</div>
            
                    <div className="card">
                        <div className="card-title">ColorPicker</div>
                        <ColorPicker inline={true} value={this.state.colorPickerValue} onChange={event => this.setState({colorPickerValue: event.value})} />
                    </div>
                </div>

                <div className="p-col-12">
                    <div className="card">
                        <div className="card-title">Input Groups</div>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-6">
                                <div className="p-inputgroup">
                                    <span className="p-inputgroup-addon"><i className="material-icons">account_circle</i></span>
                                    <InputText placeholder="Username"/>
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6">
                                <div className="p-inputgroup">
                                    <span className="p-inputgroup-addon"><i className="material-icons">credit_card</i></span>
                                    <span className="p-inputgroup-addon"><i className="material-icons">card_travel</i></span>
                                    <InputText placeholder="Payment"/>
                                    <span className="p-inputgroup-addon">$</span>
                                    <span className="p-inputgroup-addon">.00</span>
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6">
                                <div className="p-inputgroup">
                                    <InputText placeholder="Search"/>
                                    <Button icon="pi-md-search"/>
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6">
                                <div className="p-inputgroup">
                                    <span className="p-inputgroup-addon p-inputgroup-addon-checkbox">
                                        <Checkbox checked={this.state.inputGroupValue} onChange={event => this.setState({inputGroupValue: event.checked})} />
                                    </span>
                                    <InputText placeholder="Confirm"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="p-col-12">
                    <div className="card">
                        <div className="card-title">Editor</div>
                        <Editor style={{height:'320px'}} />
                    </div>
                </div>

                <div className="p-col-12 p-nogutter">
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-6">
                            <div className="card">
                                <div className="card-title">Buttons</div>

                                <div className="p-grid">
                                    <div className="p-col-12">ToggleButton</div>
                                    <div className="p-col-12">
                                        <ToggleButton checked={this.state.toggleButtonValue} onChange={event => this.setState({toggleButtonValue: event.value})} />
                                    </div>
                            
                                    <div className="p-col-12">SelectButton</div>
                                    <div className="p-col-12">
                                        <SelectButton value={this.state.selectedType} options={this.state.types} onChange={event => this.setState({selectedType: event.value})} />
                                    </div>
                            
                                    <div className="p-col-12">Button</div>
                                    <div className="p-col-12">
                                        <Button label="Bookmark"/>
                                    </div>

                                    <div className="p-col-12">Left Icon</div>
                                    <div className="p-col-12">
                                        <Button label="Clear" icon="pi-md-close" />
                                    </div>
                            
                                    <div className="p-col-12">Right Icon</div>
                                    <div className="p-col-12">
                                        <Button label="Clear" icon="pi-md-close" iconPos="right"/>
                                    </div>

                                    <div className="p-col-12">Icon Only</div>
                                    <div className="p-col-12">
                                        <Button icon="pi-md-check"/>
                                    </div>

                                    <div className="p-col-12">Link</div>
                                    <div className="p-col-12"><a href="http://www.primefaces.org">Homepage</a></div>

                                    <div className="p-col-12">SplitButton</div>
                                    <div className="p-col-12">
                                        <SplitButton label="Save" icon="pi-md-plus" model={this.state.splitButtonItems} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-col-12 p-lg-6">
                            <div className="card">
                                <div className="card-title">Colored Buttons</div>
                                <p>Flat buttons with various color alternatives.</p>
                                
                                <div className="p-grid">
                                    <div className="p-col-12 p-md-6" style={{textAlign:'center'}}>
                                        <Button label="Primary" style={{ marginBottom: 10 }} />
                                        <Button label="Inline" style={{ marginBottom: 10, width: 'auto' }} />
                                        <Button label="Secondary" style={{ marginBottom: 10 }} className="p-button-secondary" />
                                        <Button label="Green / Success" style={{ marginBottom: 10 }} className="p-button-success" />
                                        <Button label="Blue /Info" style={{ marginBottom: 10 }} className="p-button-info" />
                                        <Button label="Amber / Warning" style={{ marginBottom: 10 }} className="p-button-warning" />
                                        <Button label="Red / Danger" style={{ marginBottom: 10 }} className="p-button-danger" />
                                        <Button label="Blue-Grey Button" style={{ marginBottom: 10 }} className="blue-grey-btn flat-btn" />
                                        <Button label="Cyan Button" style={{ marginBottom: 10 }} className="cyan-btn" />
                                        <Button label="Teal Button" style={{ marginBottom: 10 }} className="teal-btn" />
                                        <Button label="Orange Button" style={{ marginBottom: 10 }} className="orange-btn" />
                                        <Button label="Deep-Orange Button" style={{ marginBottom: 10 }} className="deep-orange-btn" />
                                        <Button label="Purple Button" style={{ marginBottom: 10 }} className="purple-btn" />
                                        <Button label="Indigo Button" style={{ marginBottom: 10 }} className="indigo-btn" />
                                        <Button label="Pink Button" style={{ marginBottom: 10 }} className="pink-btn" />
                                    </div>
                                    <div className="p-col-12 p-md-6" style={{textAlign:'center'}}>
                                        <Button label="Primary Button" style={{ marginBottom: 10 }} className="flat-btn" />
                                        <Button label="Inline Button" style={{ marginBottom: 10, width: 'auto' }} className="flat-btn" />
                                        <Button label="Secondary" style={{ marginBottom: 10 }} className="p-button-secondary flat-btn" />
                                        <Button label="Green / Success" style={{ marginBottom: 10 }} className="p-button-success flat-btn" />
                                        <Button label="Blue /Info" style={{ marginBottom: 10 }} className="p-button-info flat-btn" />
                                        <Button label="Amber / Warning" style={{ marginBottom: 10 }} className="p-button-warning flat-btn" />
                                        <Button label="Red / Danger" style={{ marginBottom: 10 }} className="p-button-danger flat-btn" />
                                        <Button label="Blue-Grey Button" style={{ marginBottom: 10 }} className="blue-grey-btn flat-btn" />
                                        <Button label="Cyan Button" style={{ marginBottom: 10 }} className="cyan-btn flat-btn" />
                                        <Button label="Teal Button" style={{ marginBottom: 10 }} className="teal-btn flat-btn" />
                                        <Button label="Orange Button" style={{ marginBottom: 10 }} className="orange-btn flat-btn" />
                                        <Button label="Deep-Orange Button" style={{ marginBottom: 10 }} className="deep-orange-btn flat-btn" />
                                        <Button label="Purple Button" style={{ marginBottom: 10 }} className="purple-btn flat-btn" />
                                        <Button label="Indigo Button" style={{ marginBottom: 10 }} className="indigo-btn flat-btn" />
                                        <Button label="Pink Button" style={{ marginBottom: 10 }} className="pink-btn flat-btn" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}